/* eslint-disable no-restricted-globals */
import { get, set } from 'lodash';

import convertFloatToPercentageString from '../../helpers/convertFloatToPercentageString';

export default function formatServerData(values, fields) {
  const flattenedFields = fields.map((field) => field.fields).flat();
  const formattedValues = {};

  const fieldKeys = flattenedFields.map((field) => field.name);

  const format = (key, forcedField) => {
    const value = get(values, key);

    const flattenedField = flattenedFields.find((f) => f.name === key);

    let formattedValue = value;

    if (!flattenedField?.nullable && formattedValue === null) {
      formattedValue = '';
    }

    // If typs is 'component', return
    if (flattenedField?.type === 'component') {
      return;
    }

    // If the key is 'scheduled_rate_changes', the value is an array, iterate over each object in it
    if (flattenedField?.type === 'numberPercentageArray' && value?.length) {
      value.forEach((v, index) => {
        if (!v) {
          return;
        }
        Object.keys(v)?.forEach((k) => {
          const innerFields = flattenedFields.find(
            (f) => f.name === key
          )?.innerFields;
          const field = innerFields?.find((f) => f.name === k);
          format(`${key}[${index}].${k}`, field);
        });
      });
      return;
    }

    if (key === 'property_entities') {
      formattedValue = value[0].property_entity_id;
    }

    const field = forcedField || flattenedFields.find((f) => f.name === key);

    if (field && field.type === 'percentage') {
      formattedValue = convertFloatToPercentageString(value, false);
    }

    set(formattedValues, key, formattedValue);
  };

  fieldKeys.forEach((key) => format(key));

  const initialValues = { ...values };

  if (initialValues?.scheduled_rate_changes?.[0] === null) {
    delete initialValues.scheduled_rate_changes;
  }

  return { ...initialValues, ...formattedValues };
}
